import {AfterViewChecked, Directive, ElementRef, Input} from '@angular/core';

@Directive({
	standalone: true,
	selector: '[appAutofocus]'
})
export class AutofocusDirective implements AfterViewChecked {

	@Input() appAutofocus: boolean = true;

	constructor(private el: ElementRef) {
	}

	ngAfterViewChecked() {
		if (this.appAutofocus) {
			this.el.nativeElement.focus();
		}
	}

}
